<div class="gpd-full-page">
  <app-section-task-reopen></app-section-task-reopen>
  <app-section-schedule-change></app-section-schedule-change>
</div>